import Sidebar from "./sidebar";
import supercare from "./Assets/sc-logo.png";

const Layout = ({ children }) => {

  return (
    <>
      <Sidebar />
      <div className="md:ml-64 pt-16 md:pt-0 min-h-screen relative">
        <main className="h-full">{children}</main>

        <div className="fixed bottom-0 right-0 p-3" style={{ zIndex: 50 }}>
          <img 
            src={supercare} 
            alt="Logo" 
            className="w-20 h-30" 
            style={{
              animation: 'flipX 3s linear infinite',
              transformStyle: 'preserve-3d'
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes flipX {
          0% {
            transform: rotateY(0deg);
          }
          50% {
            transform: rotateY(180deg);
          }
          100% {
            transform: rotateY(360deg);
          }
        }
      `}</style>
    </>
  );
};

export default Layout;
